export function csrfToken() {
  const meta = document.head.querySelector('meta[name=csrf-token]')
  return meta?.content
}

export function csrfHeader() {
  const token = csrfToken()
  return token ? { 'X-CSRF-Token': token } : {}
}
